/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Event_AfterInputs */



/**
* | output |
* | --- |
* | "Insert event after" |
*
* @param {Insert_Event_AfterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_event_after = /** @type {((inputs?: Insert_Event_AfterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Event_AfterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer un événement après")
	if (locale === "de") return /** @type {LocalizedString} */ ("Füge das Ereignis nach dem")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci evento dopo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить событие после")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar evento después")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在插入事件后")
	if (locale === "ja") return /** @type {LocalizedString} */ ("後にイベントを挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इसके बाद इवेंट डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir evento após")
	return /** @type {LocalizedString} */ ("Insert event after")
});